<template>
  <v-ad-section class="c-section c-section--leaderboard"></v-ad-section>
</template>
<script>
  import { VAdSection } from '@/index/shared/components';

  export default {
    components: {
      VAdSection,
    },
  };
</script>
